import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEye = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "m15.388 12c0 .71897-.35706 1.4085-.99248 1.9169-.63555.50839-1.4974.794-2.3961.794-.89872 0-1.7606-.28561-2.3961-.794-.63549-.50839-.9925-1.1979-.9925-1.9169 0-.71897.35701-1.4085.9925-1.9169.63549-.50839 1.4974-.794 2.3961-.794.89872 0 1.7606.28561 2.3961.794.63542.50839.99248 1.1979.99248 1.9169z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.4439
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "m1.222 12c1.439-3.666 5.7211-6.3254 10.778-6.3254 5.058 0 9.3389 2.6594 10.778 6.3254-1.4391 3.666-5.72 6.3254-10.778 6.3254-5.0569 0-9.339-2.6594-10.778-6.3254z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2.4439
		})
	]
});
const ForwardRef = forwardRef(SvgEye);
export { ForwardRef as ReactComponent };
